import { VendorLocationsListAdmin } from '../../../components/Vendor';

export function VendorLocations() {
  return <VendorLocationsListAdmin />;
}
